<template>
  <header class="no-print">
    <!-- Fixed navbar -->
    <nav class="navbar navbar-expand-md static-top">
      <a class="navbar-brand" href="/">
        <img class="logo" src="@/assets/Excess White.png" />
      </a>
      <button
        v-if="user"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="fas fa-bars"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse" v-if="user">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="/">
              <font-awesome-icon icon="tachometer-alt" size="1x" />
              Administration
            </a>
          </li>
          <li v-if="user" class="nav-item">
            <router-link to="/types/admin" class="nav-link">
              <font-awesome-icon icon="bookmark" size="1x" /> Types
            </router-link>
          </li>
          <li class="nav-item active">
            <a class="nav-link" href="/help">
              <font-awesome-icon icon="question" size="1x" />
              Help
            </a>
          </li>
        </ul>
      </div>

      <b-form inline v-if="user" v-on:submit.prevent="check_injector_exists_and_jump()">
        <b-alert dismissible
          :show="show_injector_jump_message"
          :variant="injector_jump_variant"
        >
          {{ injector_jump_message }}
        </b-alert>
        <b-form-input trim
          v-model="requested_injector_id"
          placeholder="Enter injector ID"
        >
        </b-form-input>
      </b-form>
    </nav>
  </header>
</template>

<script>
import {Auth} from '@aws-amplify/auth'
import { get } from "@/utilities/requests.js";
import AmplifyStore from "@/store/store";

export default {
  name: "Nav",
  data() {
    return {
      username: "",
      password: "",
      error: "",

      requested_injector_id: null,
      injector_jump_variant: "success",
      show_injector_jump_message: false,
      injector_jump_message: "asdfasdfas"
    };
  },
  computed: {
    user() {
      return AmplifyStore.state.user;
    }
  },
  methods: {
    check_injector_exists_and_jump() {
      this.show_injector_jump_message = false;

      get(`/injector/${this.requested_injector_id}`)
        .then(response => {
          if (response.data["Items"].length > 0) {
            this.injector_jump_message = "Found injector! Jumping to report...";
            this.injector_jump_variant = "success";
            this.show_injector_jump_message = true;
            window.location = `/injectors/${this.requested_injector_id}`;
          } else {
            throw "No injector with that name";
          }
        })
        .catch(error => {
          this.injector_jump_message = "Could not find injector";
          this.injector_jump_variant = "danger";
          this.show_injector_jump_message = true;
        });
    },
    signOut: function() {
      this.$router.push("/auth/signOut");
    }
  },
  mounted2() {
    Auth.currentAuthenticatedUser().then(user => this.login(user));
  }
};
</script>

<style scoped>
div.alert {
  margin: 8pt;
  padding: 4pt;
  font-size: 20pt;  /* Increased from 16pt */
  padding-right: 16pt;
}
</style>
